import { Box } from '@mui/material';

const AvailabilitySlotValue = ({ count, freeText, isWarning = false, dense = false }) => {
  const content = (
    <>
      <Box component='span'>{count}</Box>
      <Box component='span' sx={{ fontSize: dense ? '0.8em' : '0.85em', whiteSpace: 'nowrap' }}>
        ({freeText})
      </Box>
    </>
  );

  if (!isWarning) {
    return (
      <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
        {content}
      </Box>
    );
  }

  return (
    <Box
      component='span'
      sx={theme => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        px: 0.5,
        py: '1px',
        borderRadius: 0.75,
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
        boxShadow: `0 0 0 1px ${theme.palette.error.contrastText}55`,
        whiteSpace: 'nowrap',
      })}
    >
      {content}
    </Box>
  );
};

export default AvailabilitySlotValue;
